export function conversoresEntradaSaidaInRequest(params = {}) {
  return {
    type: '@conversorEntradaSaida/CONVERSORES_ENTRADA_SAIDA_IN_REQUEST',
    payload: { params },
  };
}

export function findConversorEntradaSaida(idconversor, idposto) {
  return {
    type: '@conversorEntradaSaida/FIND_CONVERSOR_ENTRADA_SAIDA',
    payload: { idconversor, idposto },
  };
}

export function deleteConversorEntradaSaida(
  idconversor,
  idpostoOrParams,
  params
) {
  const idposto =
    typeof idpostoOrParams === 'object' ? undefined : idpostoOrParams;

  const finalParams =
    typeof idpostoOrParams === 'object' ? idpostoOrParams : params;

  return {
    type: '@conversorEntradaSaida/DELETE_CONVERSOR_ENTRADA_SAIDA',
    payload: { idconversor, idposto, params: finalParams },
  };
}

export function failedRequest() {
  return {
    type: '@conversorEntradaSaida/FAILED_REQUEST',
  };
}

export function updateData(conversorEntradaSaida, params) {
  return {
    type: '@conversorEntradaSaida/UPDATE_CONVERSOR_ENTRADA_SAIDA',
    payload: { conversorEntradaSaida, params },
  };
}

export function storeData(conversorEntradaSaida, params) {
  return {
    type: '@conversorEntradaSaida/STORE_CONVERSOR_ENTRADA_SAIDA',
    payload: { conversorEntradaSaida, params },
  };
}

export function successInRequest(
  conversoresEntradaSaida,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@conversorEntradaSaida/SUCCESS_IN_REQUEST',
    payload: {
      conversoresEntradaSaida,
      page,
      pageSize,
      totalCount,
      totalPages,
    },
  };
}

export function successRequest(conversorEntradaSaida) {
  return {
    type: '@conversorEntradaSaida/SUCCESS_REQUEST',
    payload: { conversorEntradaSaida },
  };
}

export function successRemove(params) {
  return {
    type: '@conversorEntradaSaida/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@conversorEntradaSaida/RECORD_FILTERING',
    payload: { params },
  };
}
